import React, { useEffect } from 'react';
import { initGA } from './features/analytics/analytics';
import { RouteTracker } from './features/analytics/RouteTracker';
import { FirebaseInit } from './features/firebase/common/firebaseInit';
import { watchUser } from './features/firebase/common/firebaseAuthGoogle';
import FirebasePage from './features/firebase/pages/FirebasePage';
import FirebaseFavoritesPage from './features/firebase/pages/FirebaseFavoritesPage';
import FirebaseLists2 from './features/firebase/pages/FirebaseLists2';
import FirebaseLists3 from './features/firebase/pages/FirebaseLists3';
import FirebaseLists4 from './features/firebase/pages/FirebaseLists4';
import StyxGame from './features/games/killerblocks/killerblock';
import TheBankGame from './features/games/thebank/the-bank-game';
import StyxxerGame from './features/games/styxxer/styxxer';
import SPONG from './features/games/pong/spong';
import SpaceGame from './features/games/space/space';
import ViperGame from './features/games/viper/viper';
import JimmyFrogGame from './features/games/jimmyfrog/jimmyfrog';
import Game1943 from './features/games/1943/1943';
import Game4096 from './features/games/4096/4096';
import BallBall from './features/games/ballball/ballball';
import BouncingBalls from './features/games/bouncingballs/bouncingballs';
import CrazyCars from './features/games/crazycars/carzycars';
import SynthwordGame from './features/games/synthword/synthword';
import Synthword6Game from './features/games/synthword6/synthword6';
import NumdleGame from './features/games/numdle/numdle';
import AstroshootGame from './features/games/astroshoot/astroshoot';
import './App.css';
import {
  BrowserRouter,
  Routes, Route
} from "react-router-dom";
import { selectTheme } from './features/config/configSlice';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { setIsMobile } from './features/config/configSlice';
import { Layout } from './features/shared/Layout';
import { NewLayout } from './features/shared/NewLayout';
import { AdminGuard } from './features/shared/AdminGuard';
import { Config } from './features/config/pages/Config';
// import { Home } from './features/shared/Home';
import { UnderConstruction } from './features/shared/UnderConstruction';
import { ArticleDetail } from './features/shared/ArticleDetail';
import { CompleteArticleList } from './features/shared/CompleteArticleList';
import { PlayGamesNow } from './features/games/PlayGamesNow';
import { GameDetail } from './features/games/GameDetail';
import { Login } from './features/authNew/pages/Login';
import { Logout } from './features/authNew/pages/Logout';
import { login, logout } from './features/authNew/authSlice';
import { UserSettings } from './features/userSettings/pages/UserSettings';
import { UserData } from './features/userData/pages/UserData';
import { AuthGuard } from './features/shared/AuthGuard';

//theme: now it's in Index.html: <link id="app-theme" rel="stylesheet" type="text/css" href="saga-blue.css">
// import "primereact/resources/themes/lara-light-indigo/theme.css";

//core
import "primereact/resources/primereact.min.css";

//icons
import "primeicons/primeicons.css";

// CSS
import 'primeflex/primeflex.css'


initGA();

// App entry component that wires firebase, theme, and routing.
function App() {
  let { app, analitycs } = FirebaseInit();
  const theme = useSelector(selectTheme);
  const dispatch = useDispatch();

  // Syncs firebase auth state into redux so protected routes survive refresh.
  useEffect(() => {
    // Maps firebase user data into redux auth state on login.
    const handleLogin = (user) => {
      dispatch(login({
        displayName: user?.displayName || '',
        uid: user?.uid || '',
        email: user?.email || '',
        photoURL: user?.photoURL || ''
      }));
    };

    // Clears redux auth state on logout.
    const handleLogout = () => {
      dispatch(logout());
    };

    watchUser(handleLogin, handleLogout);
  }, [dispatch]);

  // Checks if the viewport width is in the mobile range.
  const isMobileFunc = () => window.innerWidth < 720;
  // Updates the redux flag when the viewport is resized.
  const handleResize = () => {
    if (isMobileFunc()) {
      dispatch(setIsMobile(true))
    } else {
      dispatch(setIsMobile(false))
    }
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
  })
  // mobile resizing ------

  // Updates the theme stylesheet link to the current theme if it is valid.
  const changeTheme = (theme) => {
    const themeLink = document.getElementById('app-theme');
    const isValidThemePath = typeof theme === 'string' && theme.startsWith('/themes/');
    if (themeLink && isValidThemePath) {
      themeLink.href = theme;
    }
  }

  useEffect(() => changeTheme(theme), [theme])



  return (
    <div className="App">
      <RouterStructure app={app} />
    </div>
  );
}


// Defines all routes and protects logged-in sections.
function RouterStructure({ app }) {
  return <BrowserRouter>
    <RouteTracker />
    <Routes>
      <Route element={<NewLayout />}>
        <Route path="/" >
          {/* <Route index element={<Home />} /> */}
          <Route index element={<UnderConstruction />} />
          <Route path='blog/:slug' element={<ArticleDetail />} />
          <Route path='blog/*' element={<ArticleDetail />} />
          <Route path='complete-article-list' element={<CompleteArticleList />} />
          <Route path='play-games-now' element={<PlayGamesNow />} />
          <Route path='play-games-now/:slug' element={<GameDetail />} />
          <Route path='login' element={<Login />} />
          <Route path='logout' element={<Logout />} />
        </Route>
        <Route path="/killerblock" element={<StyxGame />} />
        <Route path="/the-bank" element={<TheBankGame />} />
        <Route path="/styxxer" element={<StyxxerGame />} />
        <Route path="/sbong" element={<SPONG />} />
        <Route path="/space" element={<SpaceGame />} />
        <Route path="/viper" element={<ViperGame />} />
        <Route path="/jimmyfrog" element={<JimmyFrogGame />} />
        <Route path="/1943" element={<Game1943 />} />
        <Route path="/4096" element={<Game4096 />} />
        <Route path="/ballball" element={<BallBall />} />
        <Route path="/bouncingball" element={<BouncingBalls />} />
        <Route path="/crazycars" element={<CrazyCars />} />
        <Route path="/synthword" element={<SynthwordGame />} />
        <Route path="/synthword6" element={<Synthword6Game />} />
        <Route path="/numdle" element={<NumdleGame />} />
        <Route path="/astroshoot" element={<AstroshootGame />} />
        <Route element={<AuthGuard />}>
          <Route path="userData" element={<UserData />} />
        </Route>
      </Route>
      <Route element={<Layout />}>
        <Route element={<AdminGuard />}>
          <Route path="firebase" element={<FirebasePage app={app} />} />
          <Route path="favorites" element={<FirebaseFavoritesPage app={app} />} />
          <Route path="movies" element={<FirebaseLists2 key="movies" app={app} path={'/movies/movies_db_movies.json'} />} id='2' />
          <Route path="cartoni-serie" element={<FirebaseLists2 key="cartoni-serie" app={app} path={'/movies/movies_db_cartoni_serie.json'} />} id='3' />
          <Route path="music" element={<FirebaseLists3 app={app} />} />
          <Route path="music-decades" element={<FirebaseLists4 app={app} />} />
          <Route path="config" element={<Config />} />
          <Route path="usersettings" element={<UserSettings />} />
        </Route>
      </Route>        
      <Route path="*" element={<NoMatch />} />
    </Routes>
  </BrowserRouter>;
}

// Fallback route for missing paths.
function NoMatch() {
  return <div className="p-4">
    <h2>404: PAGE NOT FOUND!</h2>
    <a href="/home">Go to Home Page</a>
  
  </div>
}

export default App;
